/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoFortnoxInvoiceRowDto } from './WebApiIntegrationsDtoFortnoxInvoiceRowDto';
import {
    WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSON,
    WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSONTyped,
    WebApiIntegrationsDtoFortnoxInvoiceRowDtoToJSON,
} from './WebApiIntegrationsDtoFortnoxInvoiceRowDto';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
 */
export interface WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    amount?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    memberIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    connectedYear?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    generateAmountFromMembership?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    printTemplate?: string | null;
    /**
     * VAT % for the legacy single manual row. Null => 0 (momsfri).
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    vat?: number | null;
    /**
     * Optional Fortnox article for the legacy single manual row.
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    articleNumber?: string | null;
    /**
     * Optional Fortnox account override for the legacy single manual row.
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    accountNumber?: number | null;
    /**
     * Optional invoice due date for the whole run. Null => Fortnox default (+30 days).
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    dueDate?: Date | null;
    /**
     * Optional invoice date for the whole run. Null => today.
     * @type {Date}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    invoiceDate?: Date | null;
    /**
     * Invoice lines applied to every selected member (manual mode). When non-empty this is used
     * and the scalar description / amount /
     * Vat / ArticleNumber / AccountNumber
     * are ignored. Not used when generateAmountFromMembership is true.
     * @type {Array<WebApiIntegrationsDtoFortnoxInvoiceRowDto>}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    rows?: Array<WebApiIntegrationsDtoFortnoxInvoiceRowDto> | null;
    /**
     * When false (default), members that aren't in Fortnox yet are skipped. When true, a Fortnox
     * customer is created for them as part of the run.
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto
     */
    createMissingCustomers?: boolean;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoFromJSON(json: any): WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto {
    return WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'memberIds': !exists(json, 'memberIds') ? undefined : json['memberIds'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'generateAmountFromMembership': !exists(json, 'generateAmountFromMembership') ? undefined : json['generateAmountFromMembership'],
        'printTemplate': !exists(json, 'printTemplate') ? undefined : json['printTemplate'],
        'vat': !exists(json, 'vat') ? undefined : json['vat'],
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'accountNumber': !exists(json, 'accountNumber') ? undefined : json['accountNumber'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? null : new Date(json['dueDate'])),
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (json['invoiceDate'] === null ? null : new Date(json['invoiceDate'])),
        'rows': !exists(json, 'rows') ? undefined : (json['rows'] === null ? null : (json['rows'] as Array<any>).map(WebApiIntegrationsDtoFortnoxInvoiceRowDtoFromJSON)),
        'createMissingCustomers': !exists(json, 'createMissingCustomers') ? undefined : json['createMissingCustomers'],
    };
}

export function WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDtoToJSON(value?: WebApiIntegrationsDtoCreateMultipleFortnoxInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'memberIds': value.memberIds,
        'connectedYear': value.connectedYear,
        'generateAmountFromMembership': value.generateAmountFromMembership,
        'printTemplate': value.printTemplate,
        'vat': value.vat,
        'articleNumber': value.articleNumber,
        'accountNumber': value.accountNumber,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate === null ? null : value.invoiceDate.toISOString()),
        'rows': value.rows === undefined ? undefined : (value.rows === null ? null : (value.rows as Array<any>).map(WebApiIntegrationsDtoFortnoxInvoiceRowDtoToJSON)),
        'createMissingCustomers': value.createMissingCustomers,
    };
}

